import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import RepetitionInterval from '@/domain/termine/components/RepetitionInterval/RepetitionInterval';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';
import { TerminWiederholung } from '@/domain/termine/shared/types/TerminWiederholung';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function RepetitionIntervalFormField({
  form,
}: {
  form: UseFormReturn<FormValues>;
}) {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name="wiederholung"
      render={({ field }) => (
        <FormItem className="flex-1">
          <FormLabel>{t('domain.termine.repeat')}</FormLabel>
          <FormControl>
            <RepetitionInterval
              value={field.value || TerminWiederholung.OHNE}
              onChange={field.onChange}
              form={form}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
